import { useState } from "react";
import "./hrt.scss";
import {
  postPrescriptionTemplate,
  postPatientReport,
  fetchPatientDetailsUuid,
  coupleIdChecker,
  postAppointment,
} from "../../Redux/Thunk/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import headerimage from "../../assets/images/ascas.svg";
import Headers from "../../Components/Header/Headers";
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter";

export default function Hrt(props) {
  const [valueChange, setvalueChange] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [patientOne_UUId, setPatientOne_UUId] = useState("");
  const patientId = useSelector((state) => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
    });

  
  const [show, setShow] = useState(false); // State to control the visibility of inputs
  const [rows2, setRows2] = useState([
    { date: "",cd:"", drugsTab: "",additional:"", et: "", r: "", l: "", zone: "" },
  ]);

  const handleAddRow = () => {
    setRows2([
      ...rows2,
      { date: "",cd:"", drugsTab: "",additional:"", et: "", r: "", l: "", zone: "" },
    ]);
  };

  const handleRemoveRow = (index) => {
    const newRows = rows2.filter((row, i) => i !== index);
    setRows2(newRows);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const newRows = [...rows2];
    newRows[index][name] = value;
    setRows2(newRows);
  };
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = (value, options = {}) => {
    const { style = { border: "1px solid black", textAlign: "center" } } =
      options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {
      style = { border: "1px solid black", textAlign: "center" },
      colspans = 1,
    } = options;
    return (
      <th colSpan={colspans} style={style}>
        {value}
      </th>
    );
  };
  const handleChangeid = (e) => {
    // const { name, value } = e.target;
    // setvalueChange({ ...valueChange, [name]: value });
    var text = e.target.value;

    if (e.target.name === "patientId1") {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === "A") {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          };
          props.loaderchange("true");
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat =
              data?.titles + " " + data?.first_name + " " + data?.last_name;
            if (e.target.name === "patientId1") {
              setPatientOne_UUId(data?.id);
              setvalueChange({
                ...valueChange,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text,
              });
            }
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === "patientId1") {
          setvalueChange({
            ...valueChange,
            patientId1: e.target.value,
          });
        }
      }
    } else {
      console.log("Going in");
      setvalueChange({ ...valueChange, [e.target.name]: e.target.value });
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T");
        setAppointmentData({
        ...appointmentData,
        date: dateTime[0],
        time: dateTime[1],
        p_uhid: props.patientsData.p_uhid,
        name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
        status: "Not Visited",
        notes: "Booking Visit",
        patient_id: patientId,
        });
        }
    }
  };
  const handlesubmit = () => {
    props.loaderchange("true");
    try {
      if (
        props.patientsData.id !== "" &&
        props.patientsData.p_uhid !== "" &&
        props.patientsData.p_uhid.length === 10
      ) {
        setShow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById(
            "prescriptionReportWrap"
          ).innerHTML;
          console.log(htmlPayload, "htmlPayload");
          // Prepare payload for creating report
          
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "Hrt",
            },
          };

          const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
            };
            createNewAppointment();

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate("/PatientView");
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
            props.loaderchange("false");
          } else {
            props.loaderchange("false");
            props.popupalert("true");
            props.popuptext("Network went wrong, Please try after some time.");
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const drugs = [
    {
      sno: 1,
      name: "C.FOLVISTA",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 2,
      name: "TAB. ECOSPIRIN (Aspirin)",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 3,
      name: "ARGIPREG SACHET/ ARGIHOPE (L-arginine Proanthocyanidin)",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 4,
      name: "TAB. VEHYCAL (Calcium+Vitamin d3)",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 5,
      name: "TAB. HCQ (Hydroxychloroquine)",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 6,
      name: "TAB. WYSOLONE (Prednisolone)",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 7,
      name: "TAB. CELIN (Vitamin C)",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 8,
      name: "TAB. PROGYNOVA (Estradiol Valerate)",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 9,
      name: "ESTOGEL/ESTROFIRST GEL",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
    {
      sno: 10,
      name: "TAB. TAMOXIFEN",
      dose: "",
      frequency: "",
      days: "",
      beforeAfterFood: "before food",
    },
  ];

  return (
    <div id="Hrt">
      <div className="Hrt">
        <h1>HRT</h1>

        <div
          className=""
          style={{ width: "100%", display: "block" }}
          id="patientInfo1"
        >
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              // src={"https://s3.amazonaws.com/likodi.com/ascslogo.png"}
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: "100%",
                margin: "0 auto",
              }}
            ></img>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          >
            <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={props.patientsData.p_uhid}
                  onChange={(e) => handleChange(e)}
                  name="patientId"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.p_uhid}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name="patientName"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChange(e)}
                  value={props.patientsData.gender}
                  name="gender"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option selected disabled>
                    Select
                  </option>
                  <option value={props.patientsData.gender}>
                    {props.patientsData.gender}
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{props.patientsData.gender}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChange(e)}
                value={props.patientsData.age}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{props.patientsData.age}
              </span>
            </div>
          </div>
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "3px",
              backgroundColor: "#f7f7f7 ",
              borderRadius: "6px",
              padding: "16px 8px 16px 8px",
              gap: "3px",
            }}
          > */}
          {/* Patient ID and Couple ID (Side by side) */}
          {/* <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Patient ID</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <input
                  type="text"
                  className={`createTime ${show ? "hide" : "show"}`}
                  value={valueChange.patientId1}
                  onChange={(e) => handleChangeid(e)}
                  name="patientId1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                  }}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.patientId1}
                </span>
              </div>
            </div> */}

          {/* Patient Name */}
          {/* <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Patient Name</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={valueChange.patientName1}
                name="patientName1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                  color: "#000",
                }}
              />
              <span
                className={`input ${!show ? "hide" : "show"}`}
                style={{ width: "100%" }}
              >
                &nbsp;{valueChange.patientName1}
              </span>
            </div> */}
          {/* Gender and Blood Group (Side by side) */}
          {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "125px 16px 250px",
                  alignItems: "center ",
                }}
              >
                <span style={{ fontWeight: 600 }}>Gender</span>
                <span style={{ fontWeight: 600 }}>: </span>
                <select
                  className={`createTime ${show ? "hide" : "show"}`}
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.gender1}
                  name="gender1"
                  style={{
                    border: "1px solid #ddd",
                    outline: "none",
                    padding: "10px",
                    backgroundColor: "white",
                  }}
                >
                  <option value="" disabled selected>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Others">Others</option>
                  <option value="Decline to State">Decline to State</option>
                </select>
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.gender1}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "125px 16px 250px",
                alignItems: "center ",
              }}
            >
              <span style={{ fontWeight: 600 }}>Age</span>
              <span style={{ fontWeight: 600 }}>: </span>
              <input
                type="text"
                className={`createTime ${show ? "hide" : "show"}`}
                onChange={(e) => handleChangeid(e)}
                value={valueChange.age1}
                name="age1"
                style={{
                  border: "1px solid #ddd",
                  outline: "none",
                  padding: "10px",
                }}
              />
              <span className={`input ${!show ? "hide" : "show"}`}>
                &nbsp;{valueChange.age1}
              </span>
            </div> */}

          {/* <div
            style={{
              display: "grid",
              gridTemplateColumns: "125px 16px 250px",
              alignItems: "center",
              // paddingLeft: "25px",
            }}
          >
            <span style={{ fontWeight: 600 }}>Blood Group</span>
            <span style={{ fontWeight: 600 }}>: </span>
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChange(e)}
              name="bloodGroup1"
              value={valueChange.bloodGroup1}
              style={{
                border: "1px solid #ddd",
                outline: "none",
                padding: "10px",
                backgroundColor: "white",
              }}
            >
              <option value="" disabled selected>
                Select Blood Group
              </option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
            </select>
            <span className={`input ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.bloodGroup1}
            </span>
          </div> */}
          {/* </div> */}
        </div>
        <div className="detail">
          {/* <p>
            Name:
            <input
              onChange={(e) => handleChangeid(e)}
              className={`createTime ${show ? "hide" : "show"}`}
              name="name"
              value={valueChange.name || ""}
            />
            <span className={`input_1 ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.name || "Name"}
            </span>
          </p> */}
          {/* <p>
            Age:
            <input
              onChange={(e) => handleChangeid(e)}
              className={`createTime ${show ? "hide" : "show"}`}
              name="age"
              value={valueChange.age || ""}
            />
            <span className={`input_1 ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.age || "Age"}
            </span>
          </p> */}
          <p>Planned for ET - CYCLE NUMBER</p>
          <p>
            Embryos available:
            <input
              onChange={(e) => handleChangeid(e)}
              className={`createTime ${show ? "hide" : "show"}`}
              name="embryosAvailable"
              value={valueChange.embryosAvailable || ""}
            />
            <span className={`input_1 ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.embryosAvailable || "Embryos available"}
            </span>
          </p>
          <p>
            Trial Cannulation:
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChangeid(e)}
              style={{ border: "1px solid gray", borderRadius: "3px" }}
              name="trialCannulation"
              value={valueChange.trialCannulation || ""}
            >
              <option selected disabled>
                Select
              </option>

              <option value="Easy">Easy</option>
              <option value="Difficult">Difficult</option>
            </select>
            <span className={`input_1 ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.trialCannulation || "Trial Cannulation"}
            </span>
          </p>
          <p>
            Shaving done:
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChangeid(e)}
              name="shavingDone"
              style={{ border: "1px solid gray", borderRadius: "3px" }}
              value={valueChange.shavingDone || ""}
            >
              <option selected disabled>
                Select
              </option>

              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
            <span className={`input_1 ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.shavingDone || "Shaving done"}
            </span>
          </p>
          <p>
            Plan:
            <select
              className={`createTime ${show ? "hide" : "show"}`}
              onChange={(e) => handleChangeid(e)}
              name="plan"
              style={{ border: "1px solid gray", borderRadius: "3px" }}
              value={valueChange.plan || ""}
            >
              <option selected disabled>
                Select
              </option>

              <option value="Regular HRT">Regular HRT</option>
              <option value="Tamoxifen HRT">Tamoxifen HRT</option>
              <option value="NC HRT">NC HRT</option>
            </select>
            <span className={`input_1 ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.plan || "Plan"}
            </span>
          </p>
          <p>
            Previous ET at EC:
            <input
              onChange={(e) => handleChangeid(e)}
              className={`createTime ${show ? "hide" : "show"}`}
              name="previousET"
              value={valueChange.previousET || ""}
            />
            <span className={`input_1 ${!show ? "hide" : "show"}`}>
              &nbsp;{valueChange.previousET || "Previous ET at EC"}
            </span>
          </p>
        </div>
        <br />
        <br />
        <br />
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>TSH</th>
              <th>Prolactin</th>
              <th>FBS/HBAIc</th>
              <th>E2</th>
            </tr>
            <tr>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="TSH"
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.TSH || ""}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.TSH || "TSH"}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="Prolactin"
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.Prolactin || ""}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.Prolactin || "Prolactin"}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="FBS"
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.FBS || ""}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.FBS || "FBS"}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="E2"
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.E2 || ""}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.E2 || "E2"}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <br />
        <br />
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>ET</th>
              <th>RIGHT OV</th>
              <th>LEFT OV</th>
            </tr>
            <tr>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="ET"
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.ET || ""}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.ET || "ET"}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="rightOV"
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.rightOV || ""}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.rightOV || "RIGHT OV"}
                </span>
              </td>
              <td>
                <input
                  className={`createTime ${show ? "hide" : "show"}`}
                  name="leftOV"
                  onChange={(e) => handleChangeid(e)}
                  value={valueChange.leftOV || ""}
                />
                <span className={`input ${!show ? "hide" : "show"}`}>
                  &nbsp;{valueChange.leftOV || "LEFT OV"}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <br />
        <br />
        <table className="table_1" border="1px" cellSpacing="0px">
          <tbody>
            <tr>
              <th>SNO</th>
              <th>DRUG</th>
              <th>DOSE</th>
              <th>FREQUENCY</th>
              <th>DAYS</th>
              <th>BEFORE/AFTER FOOD</th>
            </tr>
            {drugs.map((drug, index) => (
              <tr key={index}>
                <td>{drug.sno}</td>
                <td>{drug.name}</td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChangeid(e)}
                    name={`dose${index + 1}`}
                    value={valueChange[`dose${index + 1}`]}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange[`dose${index + 1}`]}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChangeid(e)}
                    name={`frequency${index + 1}`}
                    value={valueChange[`frequency${index + 1}`]}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange[`frequency${index + 1}`]}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    onChange={(e) => handleChangeid(e)}
                    name={`days${index + 1}`}
                    value={valueChange[`days${index + 1}`]}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange[`days${index + 1}`]}
                  </span>
                </td>
                <td>
                  <select
                    className={`createTime ${show ? "hide" : "show"}`}
                    name={`beforeAfterFood${index + 1}`}
                    onChange={(e) => handleChangeid(e)}
                    value={valueChange[`beforeAfterFood${index + 1}`]}
                  >
                    <option selected disabled>
                      Select
                    </option>

                    <option value="before food">Before Food</option>
                    <option value="after food">After Food</option>
                  </select>
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{valueChange[`beforeAfterFood${index + 1}`]}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
        <br />
        <br />
        {/* <table className="table_1" border="1px" cellSpacing="0px">
          <thead>
            <tr>
              <th>S No</th>
              <th>Date</th>
              <th>Drugs Tab. Progynova 2 mg</th>
              <th>ET</th>
              <th>R</th>
              <th>L</th>
              <th>ZONE</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                  <input
                    type="date"
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="date"
                    value={row.date}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.date}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="drugsTab"
                    value={row.drugsTab}
                    onChange={(e) => handleChange(index, e)}
                    readOnly
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.drugsTab}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="et"
                    value={row.et}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.et}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="r"
                    value={row.r}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.r}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="l"
                    value={row.l}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.l}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="zone"
                    value={row.zone}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.zone}
                  </span>
                </td>
                <td>
                  {index === 0 && (
                    <button onClick={(e) => handleAddRow(index)}>+</button>
                  )}
                  {index > 0 && (
                    <button onClick={() => handleRemoveRow(index)}>-</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}
        <table className="table_1" border="1px" cellSpacing="0px">
          <thead>
            <tr>
              <th>Date</th>
              <th>CD</th>
              <th>TAB. PROGYNOVA/ EVATONE/</th>
              <th>Additional</th>
              <th>ET</th>
              <th>R</th>
              <th>L</th>
              <th>ZONE</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows2.map((row, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="date"
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="date"
                    value={row.date}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.date}
                  </span>
                </td>
                <td>
                <input
                    
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="cd"
                    value={row.cd}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.cd}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="drugsTab"
                    value={row.drugsTab}
                    onChange={(e) => handleChange(index, e)}
                    
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.drugsTab}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="additional"
                    value={row.additional}
                    onChange={(e) => handleChange(index, e)}
                    
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.additional}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="et"
                    value={row.et}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.et}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="r"
                    value={row.r}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.r}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="l"
                    value={row.l}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.l}
                  </span>
                </td>
                <td>
                  <input
                    className={`createTime ${show ? "hide" : "show"}`}
                    name="zone"
                    value={row.zone}
                    onChange={(e) => handleChange(index, e)}
                  />
                  <span className={`input ${!show ? "hide" : "show"}`}>
                    &nbsp;{row.zone}
                  </span>
                </td>
        
                <td>
                  {index === 0 && (
                    <button onClick={(e) => handleAddRow(index)}>+</button>
                  )}
                  {index > 0 && (
                    <button onClick={() => handleRemoveRow(index)}>-</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* <p style={{ textAlign: "center", padding: "30px 10px" }}>
          x x x End Of Report x x x
        </p> */}

<p style={{fontWeight:"600"}}>
NEXT APPOINTMENT -{" "}
<input
name="nextappointment"
onChange={handleChangeid}
type="datetime-local"
// type="date"
/>
</p>
        <div className={`Footer ${show ? "hide" : "show"}`}>
          <button onClick={handlesubmit} className="Button_Create">
            Add Report
          </button>
        </div>
      </div>
      <div id="prescriptionReport">
        <div id="prescriptionReportWrap">
          <Headers />
          <p class="Dani"></p>
          <div
            className="patient"
            style={{
              border: "1px solid black",
              borderRadius: "10px",
              marginBottom: "10px",
            }}
          >
            <div
              className="nameToAgeContainer"
              style={{ display: "flex", marginBottom: "10px" }}
            >
              {renderReportfield(
                "Patient Name :",
                `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
              )}
              {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
              {renderReportfield("Gender :", props.patientsData.gender)}
              {renderReportfield("Age :", props.patientsData.age)}
            </div>
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Planned for ET - CYCLE NUMBER")}
            {renderReportfield(
              "Embryos available :",
              valueChange.embryosAvailable
            )}
            {renderReportfield(
              "Trial Cannulation :",
              valueChange.trialCannulation
            )}
            {renderReportfield("Shaving done :", valueChange.shavingDone)}
            {renderReportfield("Plan :", valueChange.plan)}
          </div>
          <div style={{ display: "flex", marginBottom: "10px" }}>
            {renderReportfield("Previous ET at EC :", valueChange.previousET)}
          </div>
          <div>
            <table style={{ width: "100%", marginBottom: "10px" }}>
              <thead>
                {["TSH", "Prolactin", "FBS/HBAIc", "E2"].map((ele) =>
                  renderTableTH(ele)
                )}
              </thead>
              <tbody>
                <tr>
                  {renderTableTD(valueChange.TSH)}
                  {renderTableTD(valueChange.Prolactin)}
                  {renderTableTD(valueChange.FBS)}
                  {renderTableTD(valueChange.E2)}
                </tr>
              </tbody>
            </table>
          </div>{" "}
          <div>
            <table style={{ width: "100%", marginBottom: "30px" }}>
              <thead>
                {["ET", "RIGHT OV", "LEFT OV"].map((ele) => renderTableTH(ele))}
              </thead>
              <tbody>
                <tr>
                  {renderTableTD(valueChange.ET)}
                  {renderTableTD(valueChange.rightOV)}
                  {renderTableTD(valueChange.leftOV)}
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table style={{ width: "100%", marginBottom: "30px" }}>
              <thead>
                {[
                  "SNO",
                  "DRUG",
                  "DOSE",
                  "FREQUENCY",
                  "DAYS",
                  "BEFORE/AFTER FOOD",
                ].map((ele) => renderTableTH(ele))}
              </thead>
              <tbody>
                {drugs.map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele.sno)}
                      {renderTableTD(ele.name)}
                      {renderTableTD(valueChange[`dose${ind + 1}`])}
                      {renderTableTD(valueChange[`frequency${ind + 1}`])}
                      {renderTableTD(valueChange[`days${ind + 1}`])}
                      {renderTableTD(valueChange[`beforeAfterFood${ind + 1}`])}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div>
            <table style={{ width: "100%", marginBottom: "30px" }}>
              <thead>
                {[
                  "Date",
                  "CD",
                  "TAB. PROGYNOVA/ EVATONE/",
                  "Additional",
                  "ET",
                  "R",
                  "L",
                  "Zone",
                ].map((ele) => renderTableTH(ele))}
              </thead>
              <tbody>
                {rows2.map((ele, ind) => {
                  return (
                    <tr key={ind}>
                      {renderTableTD(ele.date)}
                      {renderTableTD(ele.cd)}
                      {renderTableTD(ele.drugsTab)}
                      {renderTableTD(ele.additional)}
                      {renderTableTD(ele.et)}
                      {renderTableTD(ele.r)}
                      {renderTableTD(ele.l)}
                      {renderTableTD(ele.zone)}

                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: "10px" }}>
{renderReportfield("Next Appointment : ",appointmentData.date?.split("-").reverse().join("-"))}
</div>
<p class="Dani"></p>
<PrescriptionFooter/>
        </div>
      </div>
    </div>
  );
}
